import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { LightText } from "./HXMobilePage.styles";
export const PatientConsentOrgSharingTitle = styled(LightText) `
    margin-right: 12px;
    font-size: ${fontSizes.LITTLE};
    text-align: left;
    flex: 1;
`;
